export function findSegmentIndexFromHandlePoint(handle, segmentsMeta, opts = {}) {
    var _a;
    const tol = (_a = opts.tolerance) !== null && _a !== void 0 ? _a : 6;
    const tol2 = tol * tol;
    let bestIdx = -1;
    let bestD2 = Number.POSITIVE_INFINITY;
    for (let i = 0; i < segmentsMeta.length; i++) {
        const seg = segmentsMeta[i];
        const d2 = distPointToOrthoSegmentSquared(handle, seg.a, seg.b);
        if (d2 < bestD2) {
            bestD2 = d2;
            bestIdx = i;
        }
    }
    if (bestIdx === -1 || bestD2 > tol2)
        return -1;
    const eps = 1e-9;
    const candidates = [];
    for (let i = 0; i < segmentsMeta.length; i++) {
        const d2 = distPointToOrthoSegmentSquared(handle, segmentsMeta[i].a, segmentsMeta[i].b);
        if (Math.abs(d2 - bestD2) < eps)
            candidates.push(i);
    }
    if (candidates.length > 1) {
        let chosen = candidates[0];
        let bestLen2 = segLen2(segmentsMeta[chosen].a, segmentsMeta[chosen].b);
        for (let k = 1; k < candidates.length; k++) {
            const idx = candidates[k];
            const len2 = segLen2(segmentsMeta[idx].a, segmentsMeta[idx].b);
            if (len2 > bestLen2) {
                bestLen2 = len2;
                chosen = idx;
            }
        }
        return chosen;
    }
    return bestIdx;
}
function segLen2(a, b) {
    const dx = b.x - a.x;
    const dy = b.y - a.y;
    return dx * dx + dy * dy;
}
function distPointToOrthoSegmentSquared(p, a, b) {
    // horizontal
    if (a.y === b.y) {
        const y = a.y;
        const minX = Math.min(a.x, b.x);
        const maxX = Math.max(a.x, b.x);
        if (p.x >= minX && p.x <= maxX) {
            const dy = p.y - y;
            return dy * dy;
        }
        // closest endpoint
        const ex = p.x < minX ? minX : maxX;
        const dx = p.x - ex;
        const dy = p.y - y;
        return dx * dx + dy * dy;
    }
    // vertical
    const x = a.x;
    const minY = Math.min(a.y, b.y);
    const maxY = Math.max(a.y, b.y);
    if (p.y >= minY && p.y <= maxY) {
        const dx = p.x - x;
        return dx * dx;
    }
    const ey = p.y < minY ? minY : maxY;
    const dx = p.x - x;
    const dy = p.y - ey;
    return dx * dx + dy * dy;
}
